module.exports = __webpack_public_path__ + "img/logo_opci.c5071238.png";